import React from "react";
import Footer from "../../footer";
import { connect } from "react-redux";
import { fetchTeacherScheduleSuccess, changeStatusEdit } from "../../../store/actions/index";
import Ball from "../../../assets/Ball.svg";
import DataTable from "./DataTable";
import AccessList from "./AccessList";
import axiosInstance from "../../../store/services/AxiosService";

class Home extends React.Component {
	constructor(props) {
		super(props);
		this._isMounted = false;
		this.state = {
			errorServer: false,
			listKosong: [],
			listSchedule: [],
			activeTab: "jadwal",
			isLoading: true,
		};
	}

	componentDidMount() {
		this._isMounted = true;
		this.fetchSchedule();
	}

	fetchSchedule() {
		console.log("DEBUG: userRoleId is", this.props.userRoleId, "type:", typeof this.props.userRoleId);
		const isAdmin = parseInt(this.props.userRoleId, 10) === 1;
		console.log("DEBUG: isAdmin parsed is", isAdmin);
		const endpoint = isAdmin 
			? `/schedules/teacher/${this.props.userId}/school/${this.props.schoolId}?isAdmin=true`
			: `/schedules/teacher/${this.props.userId}/school/${this.props.schoolId}`;
		console.log("DEBUG: fetching endpoint", endpoint);

		axiosInstance
			.get(endpoint)
			// axiosInstance
			// 	.get(`/schedules/teacher/${this.props.userId}/school/${this.props.schoolId}`)
			.then((response) => {
				// this.props.fetchTeacherScheduleSuccess(response.data);
				this.setState({ listSchedule: response.data, isLoading: false });
			})
			.catch((error) => {
				this.props.fetchTeacherScheduleSuccess(this.state.listKosong);
				this.setState({ isLoading: false });
				if (error.response && error.response.status === 422) {
					console.error("Backend Error Message:", error.response.data.message);
					this.setState({ errorServer: true });
				}
			});
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidUpdate() {
		if (this.props.finishEdit === true) {
			this.props.changeStatusEdit(false);
			this.fetchSchedule();
		}
	}

	render() {
		return (
			<div className="main-panel">
				<div className="content-wrapper">
					<div className="page-header">
						<h3 className="page-title">
							<span className="page-title-icon bg-gradient-primary text-white mr-2">
								<i className="mdi mdi-home"></i>
							</span>
							Dashboard
						</h3>
						{this.state.errorServer === true ? (
							<nav aria-label="breadcrumb">
								<ul className="breadcrumb">
									<li className="breadcrumb-item active" aria-current="page" style={{ color: "red" }}>
										<span></span>Belum ada jadwal yang dibuat
										<i className="mdi mdi-alert-circle-outline icon-sm text-primary align-middle"></i>
									</li>
								</ul>
							</nav>
						) : null}
					</div>

					<div className="row">
						<div className="col-12 grid-margin">
							<div className="card custom-card-shadow">
								<div className="card-header py-3">
									<ul className="nav nav-tabs card-header-tabs" role="tablist">
										<li className="nav-item">
											<button
												className={`nav-link ${this.state.activeTab === 'jadwal' ? 'active' : ''}`}
												onClick={() => this.setState({ activeTab: 'jadwal' })}
												type="button"
												role="tab"
											>
												<i className="mdi mdi-calendar-text mr-1"></i>
												Jadwal
											</button>
										</li>
										<li className="nav-item">
											<button
												className={`nav-link ${this.state.activeTab === 'akses' ? 'active' : ''}`}
												onClick={() => this.setState({ activeTab: 'akses' })}
												type="button"
												role="tab"
											>
												<i className="mdi mdi-key-variant mr-1"></i>
												List Akses
											</button>
										</li>
									</ul>
								</div>
								<div className="card-body">
									{this.state.activeTab === 'jadwal' ? (
										this.state.isLoading ? (
											<div className="d-flex justify-content-center">
												<img src={Ball} className="img-fluid" alt="" />
											</div>
										) : this.state.listSchedule.length === 0 ? (
											<div className="d-flex justify-content-center">
												<p className="text-muted">Belum ada jadwal yang dibuat</p>
											</div>
										) : (
											<DataTable listSchedule={this.state.listSchedule} data={this.dataset} />
										)
									) : (
										<AccessList schoolId={this.props.schoolId} />
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		finishEdit: state.User.statusEditFinished,
		userId: state.User.dataTeacher.user.data_employee.employee_id,
		userRoleId: state.User.dataTeacher.user.role_id,
		schoolId: state.User.dataSchool.value,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchTeacherScheduleSuccess: (listSchedule) => dispatch(fetchTeacherScheduleSuccess(listSchedule)),
		changeStatusEdit: (status) => dispatch(changeStatusEdit(status)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
